import { useState } from 'react';
import { Link } from 'react-router-dom';
import { initAnalytics } from '../lib/analytics';
import { analyticsConfigured, readConsent, writeConsent } from '../lib/consent';

/**
 * Bottom bar asking for analytics consent. Rendered only on builds with a GA id
 * and only until the visitor chooses; the choice lives in localStorage and can
 * be reset from the privacy page.
 */
export function CookieConsent() {
  const [choice, setChoice] = useState(readConsent);
  if (!analyticsConfigured() || choice) return null;

  const decide = (value: 'accepted' | 'declined') => {
    writeConsent(value);
    setChoice(value);
    if (value === 'accepted') initAnalytics();
  };

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="rise-in fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-night-900/95 px-4 py-4 backdrop-blur"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-ink-200">
          We use one analytics cookie (Google Analytics) to see which pages help people. Nothing
          else is tracked, and reservations work either way. See the{' '}
          <Link to="/privacy" className="text-pink-300 underline">
            privacy page
          </Link>
          .
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            className="btn-outline !px-5 !py-2 text-[13px]"
            onClick={() => decide('declined')}
          >
            Decline
          </button>
          <button
            type="button"
            className="btn-primary !px-5 !py-2 text-[13px]"
            onClick={() => decide('accepted')}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
